let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gOpe6")).then(() => parcelRequire('agboS'));